/*
    Copyright 2023 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import { SemConvTrace } from "..";

const cHttpHeadersToCapture: Record<string, string> = {
	"user-agent": SemConvTrace.HTTP_USER_AGENT,
	"referer": SemConvTrace.DT_HTTP_REQUEST_HEADER_REFERER,
	"host": SemConvTrace.HTTP_HOST,
	"x-dynatrace-test": SemConvTrace.DT_HTTP_REQUEST_HEADER_X_DYNATRACE_TEST,
	"x-dynatrace-tenant": SemConvTrace.DT_HTTP_REQUEST_HEADER_X_DYNATRACE_TENANT
};

/**
 * @returns HTTP headers which must be captured into span attributes by our instrumentation.
 */
export function getHttpHeadersToCapture(): Record<string, string> {
	return cHttpHeadersToCapture;
}
